import React from 'react'
import PropTypes from 'prop-types'
import theme from 'styles/theme'
import IconWrapper from './IconWrapper'

const WhatsappIcon = ({ color, width, height, display, ...rest }) => (
  <IconWrapper width={width} height={height} display={display}>
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}>
      <g fill="none" fillRule="evenodd">
        <path fill="none" d="M0 0h32v32H0z" />
        <path
          d="M24.503 7.504A11.87 11.87 0 0016.05 4C9.463 4 4.103 9.36 4.1 15.949a11.924 11.924 0 001.595 5.974L4 28.115l6.335-1.661a11.935 11.935 0 005.71 1.455h.005c6.586 0 11.948-5.361 11.95-11.95a11.878 11.878 0 00-3.497-8.455z"
          stroke={color || '#455255'}
        />
        <path
          d="M21.498 18.449c-.298-.15-1.766-.872-2.04-.974-.274-.103-.473-.15-.672.15-.198.298-.77.97-.945 1.17-.174.2-.348.224-.647.074-.298-.15-1.26-.465-2.401-1.482-.888-.791-1.49-1.769-1.662-2.068-.172-.3-.018-.458.131-.61.134-.133.299-.348.448-.523.149-.175.2-.298.298-.498.1-.2.05-.373-.024-.523-.075-.15-.672-1.62-.921-2.217-.243-.582-.488-.503-.672-.515-.172-.009-.373-.01-.573-.01a1.097 1.097 0 00-.796.373c-.273.299-1.045 1.02-1.045 2.49 0 1.47 1.07 2.89 1.22 3.09.148.199 2.105 3.215 5.099 4.508.556.24 1.124.45 1.702.63.715.23 1.366.196 1.88.12.573-.087 1.767-.723 2.016-1.42.25-.698.249-1.296.172-1.42-.077-.125-.27-.194-.568-.343v-.002z"
          stroke={color}
          fill={color || '#455255'}
        />
      </g>
    </svg>
  </IconWrapper>
)

WhatsappIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.number),
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.number),
  ]),
  display: PropTypes.string,
}

WhatsappIcon.defaultProps = {
  color: theme.colors.coaldark,
  width: '32px',
  height: '32px',
  display: 'block',
}

export default WhatsappIcon
